import { useEffect } from 'react';
import styles from './styles';
import Label from 'components/Label';

const PurpleMessageMobile = () => {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 640px)');

    const handleResize = () => {
      if (mediaQuery.matches) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    };

    handleResize();

    mediaQuery.addEventListener('change', handleResize);

    return () => {
      mediaQuery.removeEventListener('change', handleResize);
      document.body.style.overflow = '';
    };
  }, []);
  return (
    <>
      <div className="purple-container">
        <div className="purple-message">
          Want to shop the suggested look? Make sure to select <br />
          the<Label type="purple" text="Suggested Look" /> components when
          customising your PC!
        </div>
        <img
          className="message-star1"
          src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Star_1.png?v=1716896323"
        />
        <img
          className="message-star2"
          src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Star_1.png?v=1716896323"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default PurpleMessageMobile;
